import React, { useEffect, useRef, useState } from "react";
import moment from "moment";
import { Navigate, useNavigate } from "react-router-dom";
import { Input, Loading, Table } from "Components";
import { Button, Menu, MenuItem, Box, Modal, Typography } from "@mui/material";
import {
  LuChevronDown,
  LuExternalLink,
  LuImagePlus,
  LuMoreHorizontal,
  LuPlusCircle,
  LuSearch,
  LuUpload,
  LuX,
} from "react-icons/lu";
import { switchStatusColor } from "Helpers/switchStatusColor";
import { switchSortedByValue } from "Helpers/switchSortedByValue";
// import { useOrderApis, useUpdateOrderStatus } from "./UseOrderApis";
import { useAuth } from "Context/AuthContext";
import image from "../../../Assets/capputino.png";
import "./style.css";
import { handleFileUpload } from "Helpers/uploadImageApi";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export const DashboardCategories = () => {
  const navigate = useNavigate();
  const { authorizationToken, logout } = useAuth();

  const [orderMenu, setOrderMenu] = useState(null);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [openModal, setOpenModal] = useState(null);

  const [searchKeywords, setSearchKeywords] = useState("");
  const searchInputRef = useRef(null);

  const handleSubmitSearch = (e) => {
    e.preventDefault();
    setSearchKeywords(searchInputRef.current.value);
  };

  const [selectedOption, setSelectedOption] = useState("all");

  const [filterMenu, setFilterMenu] = useState(false);
  const [filteredBy, setFilteredBy] = useState("all");
  const handleFilteredBy = (option) => {
    setFilteredBy(option);
    setFilterMenu(false);
  };

  const [tableCurrentPage, setTableCurrentPage] = useState(1);
  const tableLimit = 20;

  // const {
  //   data: orderData,
  //   isLoading,
  //   status,
  //   error,
  //   refetch,
  // } = useOrderApis({
  //   limit: tableLimit,
  //   page: tableCurrentPage,
  //   status: selectedOption,
  //   time: filteredBy,
  // });
  // useEffect(() => {
  //   refetch();
  // }, [tableCurrentPage, selectedOption, filteredBy, refetch]);

  // const mutation = useUpdateOrderStatus();

  // const updateStatusById = async (id, newStatus) => {
  //   try {
  //     const response = await mutation.mutateAsync({
  //       orderId: id,
  //       data: { status: newStatus },
  //     });
  //     if (!response.success) {
  //       alert(response.message);
  //     }
  //     return response;
  //   } catch (error) {
  //     return null;
  //   }
  // };
  const [formData, setFormData] = useState({});
  const handleChangeImage = async (e) => {
    try {
      let response = await handleFileUpload(
        authorizationToken(),
        e.target.files[0]
      );
      setFormData((prevData) => ({
        ...prevData,
        image: response.data.image,
      }));
    } catch (err) {
      console.err(err);
    }
  };
  return (
    <div className="flex_c gap-30">
      <div className="flex_r space_between align_items_center">
        <h1>Categories: 7</h1>
        <Button
          variant="outlined"
          className="outlined-btn"
          startIcon={<LuPlusCircle />}
          onClick={() => {
            setOpenModal("add");
            // setFormData({});
          }}
        >
          Add Category
        </Button>
        <Modal
          open={openModal === "add"}
          // onClose={() => {
          //   setOpenModal(null);
          //   setFormData({});
          // }}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style} className="modal-content-wrapper">
            <Typography id="modal-modal-title" variant="h6" component="h2">
              <div
                className="flex_r"
                style={{ justifyContent: "space-between" }}
              >
                Add New Category
                <LuX
                onClick={() => {
                  setOpenModal(null);
                  setFormData({});
                }}
                />
              </div>
            </Typography>
            <Typography
              id="modal-modal-description"
              sx={{
                mt: 2,
                display: "flex",
                flexDirection: "column",
                gap: "20px",
              }}
            >
              <Input
                type="text"
                label={"Category Name"}
                id="categoryName"
                placeholder="Category Name"
                required
                className="checkout_input"
                name="category-name"
                // onChange={handleChange}
              />
              <div className="flex_c gap-10">
                <label className="label">Category Description</label>
                <textarea
                  className="custom_textarea checkout_input"
                  placeholder="Category Description"
                  name="description"
                  required
                  // onChange={handleChange}
                ></textarea>
              </div>
            
              <label className="label_inputs">
                <span className="label">Category Image</span>
                <div className="flex_r space_between image_input align_items_center">
                  <div className="flex_r gap-10 align_items_center">
                    {formData.image ? (
                      <img src={formData.image} alt={formData.name} />
                    ) : (
                      <div className="image_placeholder">
                        <LuImagePlus />
                      </div>
                    )}
                    <p>Upload Image</p>
                  </div>
                  <input
                    id="productImage"
                    type="file"
                    hidden
                    onChange={handleChangeImage}
                  />
                  <LuUpload />
                </div>
              </label>
              <div className="flex_r gap-20 product_Modal_btn">
                <button
                  className="product_Modal_btn_cancel"
                  onClick={() => {
                    setOpenModal(null);
                    setFormData({});
                  }}
                >
                  Cancel
                </button>
                <button
                  className="product_Modal_btn_save"
                  // onClick={() => {
                  //   createProduct();
                  //   setOpenModal(null);
                  // }}
                >
                  Save Category
                </button>
              </div>
            </Typography>
          </Box>
        </Modal>
      </div>
      <div
        className="flex_r gap-40 space_between align_items_center"
        style={{ alignItems: "center" }}
      >
        <div className="flex_r gap-20 align_items_center">
          <h1 className="dashboard_title">
            Order:
            {/* {orderData?.totalItems || "-"}{" "} */}
          </h1>
          <Button
            id="products-sort-button"
            endIcon={<LuChevronDown />}
            aria-controls={filterMenu ? "products-sort-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={filterMenu ? "true" : undefined}
            onClick={(e) => setFilterMenu(true)}
            variant="outlined"
            className="outlined-btn"
          >
            {switchSortedByValue(filteredBy)}
          </Button>
          <Menu
            id="products-sort-menu"
            anchorEl={document.getElementById("products-sort-button")}
            open={filterMenu}
            onClose={() => setFilterMenu(false)}
            MenuListProps={{
              "aria-labelledby": "products-sort-button",
            }}
          >
            <MenuItem onClick={() => handleFilteredBy("all")}>
              All Times
            </MenuItem>
            <MenuItem onClick={() => handleFilteredBy("today")}>Today</MenuItem>
            <MenuItem onClick={() => handleFilteredBy("lastWeek")}>
              Last Week
            </MenuItem>
            <MenuItem onClick={() => handleFilteredBy("lastMonth")}>
              Last Month
            </MenuItem>
            <MenuItem onClick={() => handleFilteredBy("last6Months")}>
              Last 6 months
            </MenuItem>
            <MenuItem onClick={() => handleFilteredBy("lastYear")}>
              Last Year
            </MenuItem>
          </Menu>
        </div>
        <form
          className="dashboard_product_searchbar_container"
          onSubmit={handleSubmitSearch}
        >
          <Input
            ref={searchInputRef}
            className="outlined_input"
            type={"text"}
            placeholder="Search"
            // value={searchKeywords}
            name={"keywords"}
            // onChange={handleChangeSearch}
            startIcon={<LuSearch />}
          />
        </form>
      </div>

      <div className="flex_c gap-20">
        <div className="dashboard_table_container">
          <Table
            heading={["IMAGE", "NAME", "DESCRIPTION", "PRODUCTS", "STATUS", ""]}
            // currentPage={orderData?.currentPage}
            // totalPages={orderData?.totalPages}
            // onSelectPage={(page) => setTableCurrentPage(page)}
            // onNextPage={() => setTableCurrentPage(tableCurrentPage + 1)}
            // onPreviousPage={() => setTableCurrentPage(tableCurrentPage - 1)}
          >
            {/* {isLoading ? (
                <Loading />
              ) : ( */}
            {/* orderData?.items.map((order) => ( */}
            <tr
            // key={order._id}
            >
              <td>
                <img
                  src={image}
                  alt={"kousa"}
                  className="dashboard_table_row_img"
                />
              </td>
              <td>
                {/* {moment(order.createdAt).format("YYYY-MM-DD HH:mm:ss")} */}2
              </td>
              <td>
                {/* {order.customerInfo.name} */}
                12
              </td>
              <td>
                ${/* {order.total} */}
                12
              </td>
              <td>
                {/* <Button
                      id={`product-status-button-${product._id}`}
                      aria-controls={
                        selectedProduct === product._id
                          ? `product-status-menu-${product._id}`
                          : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={
                        selectedProduct === product._id ? "true" : undefined
                      }
                      onClick={(e) => {
                        setSelectedProduct(product._id);
                        setProductMenu("status");
                      }}
                      endIcon={<LuChevronDown />}
                      style={{
                        fontSize: "14px",
                        color: switchStatusColor(product.status),
                        border: `2px solid ${switchStatusColor(
                          product.status
                        )}`,
                      }}
                    >
                      {product.status}
                    </Button>
                    <Menu
                      id={`product-status-menu-${product._id}`}
                      anchorEl={document.getElementById(
                        `product-status-button-${product._id}`
                      )}
                      open={
                        selectedProduct === product._id &&
                        productMenu === "status"
                      }
                      onClose={() => setSelectedProduct(null)}
                      MenuListProps={{
                        "aria-labelledby": `product-status-button-${product._id}`,
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          updateStatusById(product._id, "published");
                          setSelectedProduct(null);
                        }}
                        style={{ color: "green" }}
                      >
                        Published
                      </MenuItem>
                      <MenuItem
                        onClick={() => {
                          updateStatusById(product._id, "draft");
                          setSelectedProduct(null);
                        }}
                        style={{ color: "red" }}
                      >
                        Draft
                      </MenuItem>
                    </Menu> */}
              </td>
              <td>
                <LuMoreHorizontal
                // onClick={
                //   () => navigate(`/dashboard/orders/${order._id}`)}
                />
              </td>
            </tr>
            {/* ))
              )} */}
          </Table>
        </div>
      </div>
    </div>
  );
};
